import { useContext, useEffect } from "react";
import useFirestore from "../basic/useFirestore";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { FirebaseContext } from "../../providers/FirebaseProvider/FirebaseProvider";

function useLessonsByPaymentId(paymentId, preventCall) {
  const { firestoreDb } = useContext(FirebaseContext);
  const firestoreQueryMethod = async () =>
    getDocs(
      query(
        collection(firestoreDb, "lesson-logs"),
        where("payment_id", "==", paymentId),
        orderBy("from_date", "asc"),
      ),
    );

  const parsingFuntion = (data) => {
    const parsedData = data.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      };
    });
    return parsedData;
  };

  const { data, error, isLoading, refreshData } = useFirestore(
    firestoreQueryMethod,
    parsingFuntion,
    preventCall,
  );

  useEffect(() => {
    if (preventCall) return;
    refreshData();
  }, [paymentId, preventCall]);

  return {
    data,
    error,
    isLoading,
    refreshData,
  };
}

export default useLessonsByPaymentId;
